const Columns = () => {
    return {
        setColumns(value) {
            let date = new Date();

            date.setFullYear(date.getFullYear() + 1);

            let expires = "; expires=" + date.toUTCString();

            document.cookie = `number-of-grid-columns=${value}${expires}; path=/`;

            this.columns = value;

            this.$dispatch('updated-columns', value);

            // if (typeof addBreadcrumb === 'function') {
            //     addBreadcrumb({ message: `Updating columns to ${value}` });
            // }
        }
    }
}

export default Columns;